import { IconSearch16 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './LeftAdornment.css';

export const LeftAdornment = () => {
  return (
    <div className={styles['container']}>
      <IconSearch16 color="primary_100" display="block" />
    </div>
  );
};
